import { Tool } from '../../types';

export const customerSupportTools: Tool[] = [
  // Keep existing tools
  {
    id: 'intercom',
    name: 'Intercom',
    // ... rest of Intercom config
    category: 'Customer Support',
    description: 'Modern customer messaging platform with live chat, help center, and automation',
    pricing: ['medium', 'high'],
    features: [
      'automation',
      'mobile',
      'integrations',
      'support',
      'ease-of-use'
    ],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'e-commerce', 'service-business'],
    goals: ['enhance-customer-service', 'automate-tasks'],
    industries: ['technology', 'retail', 'marketing'],
    website: 'https://www.intercom.com',
    imageUrl: 'https://logo.clearbit.com/intercom.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'drift',
    name: 'Drift',
    category: 'Customer Support',
    description: 'Conversational marketing and sales platform with chatbots and automation',
    pricing: ['medium', 'high'],
    features: [
      'automation',
      'mobile',
      'integrations',
      'support',
      'ease-of-use'
    ],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'service-business', 'marketing'],
    goals: ['enhance-customer-service', 'increase-sales'],
    industries: ['technology', 'marketing', 'consulting'],
    website: 'https://www.drift.com',
    imageUrl: 'https://logo.clearbit.com/drift.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate'],
    minTeamSize: 'small'
    // ... rest of Drift config
  },
  {
    id: 'zendesk',
    name: 'Zendesk',
    category: 'Customer Support',
    description: 'Complete customer service platform trusted by 170,000+ businesses. Unified ticketing system, knowledge base, live chat, and phone support in one solution. AI-powered automation and analytics help teams deliver faster, more personalized support.',
    pricing: ['medium', 'high'],
    features: [
      'automation',
      'integrations',
      'mobile',
      'scalability',
      'support',
      'ease-of-use'
    ],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['e-commerce', 'saas', 'service-business'],
    goals: ['enhance-customer-service', 'streamline-operations'],
    industries: ['technology', 'retail', 'finance'],
    website: 'https://www.zendesk.com',
    imageUrl: 'https://logo.clearbit.com/zendesk.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'freshdesk',
    name: 'Freshdesk',
    category: 'Customer Support',
    description: 'Intuitive helpdesk software that converts support emails into tickets for easy tracking. Features include team collaboration, knowledge base, automations, and reporting. Free tier available makes it ideal for startups and growing businesses.',
    pricing: ['free', 'medium'],
    features: [
      'automation',
      'mobile',
      'integrations',
      'support',
      'ease-of-use'
    ],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['e-commerce', 'saas'],
    goals: ['enhance-customer-service', 'streamline-operations'],
    industries: ['technology', 'retail', 'education'],
    website: 'https://freshdesk.com',
    imageUrl: 'https://images.unsplash.com/photo-1549923746-c502d488b3ea',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];